package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * 界面级 `font { name = "..."; bold = ...; italic = ...; shadow = ... }` 块的 AST。
 *
 * 四个字段均可选（三态：null=未声明/继承上层）。编译期由 ScreenEmitter 转成
 * IR 的 [top.wcpe.allincore.dsl.ir.model.UiScreenFont]，运行时写入 RendererRegistry.pageFont，
 * 经 FontAccess 页面层作用于本界面所有文字。
 */
data class FontStyleAst(
    val name: String? = null,
    val bold: Boolean? = null,
    val italic: Boolean? = null,
    val shadow: Boolean? = null,
    override val position: SourcePosition,
) : AstNode
